/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function init() {
  $('[data-header-star]').on('click', function () {
    const body = $('body')
    const pageTextTheme = body.data('color')
    const pageTheme = pageTextTheme.replace('text-', '')
    const windowFrame = $('[data-window-frame]')
    const windowFrameLeftText = $('.window-frame-bottom-left-text')
    const windowFrameRightText = $('.window-frame-bottom-right-text')

    // addFrameClasses(windowFrame, windowFrameLeftText, windowFrameRightText, pageTheme)
    // setTimeout(() => {
    //   removeFrameClasses(windowFrame, windowFrameLeftText, windowFrameRightText, pageTheme)
    // }, 2000)
  })

  $('.hero-logo').on('click', function () {
    const heroSquare1 = $('[data-hero-square="1"]')
    const heroSquare2 = $('[data-hero-square="2"]')
    const heroSquare3 = $('[data-hero-square="3"]')
    const heroSquare4 = $('[data-hero-square="4"]')
    const heroSquare5 = $('[data-hero-square="5"]')

    heroSquare1.toggleClass('hero-square-rotating-anti-clockwise')
    heroSquare3.toggleClass('hero-square-rotating-anti-clockwise')
    heroSquare5.toggleClass('hero-square-rotating-anti-clockwise')

    heroSquare2.toggleClass('hero-square-rotating-clockwise')
    heroSquare4.toggleClass('hero-square-rotating-clockwise')
  })
}

// const addFrameClasses = (windowFrame, windowFrameLeftText, windowFrameRightText, pageTheme) => {
//   if (windowFrame.hasClass('border-color-black')) {
//     windowFrame.removeClass(`border-color-black`)
//     windowFrame.addClass(`border-color-${pageTheme}`)
//   }

//   windowFrameLeftText.toggleClass('text-black')
//   windowFrameRightText.toggleClass('text-black')
// }

// const removeFrameClasses = (windowFrame, windowFrameLeftText, windowFrameRightText, pageTheme) => {
//   windowFrame.removeClass(`border-color-${pageTheme}`)
//   windowFrame.addClass('border-color-black')

//   windowFrameLeftText.toggleClass('text-black')
//   windowFrameRightText.toggleClass('text-black')
// }
